import React, {useEffect, useRef, useState} from "react";
import {Button, InputNumber, Popover, Space, message} from "antd";
import {EditOutlined} from "@ant-design/icons";
import {useStore} from "hooks/useStore";
import {useFetch} from "hooks/useFetch";

export const CodLimitOffsetEditPopover = ({courierId, cashOnDeliveryLimitOffset, onSuccess}) => {
    const stores = useStore();
    const [visible, setVisible] = useState(false);
    const [newLimitOffset, setNewLimitOffset] = useState(cashOnDeliveryLimitOffset);
    const payloadRef = useRef({});

    useEffect(() => {
        setNewLimitOffset(cashOnDeliveryLimitOffset);
    }, [cashOnDeliveryLimitOffset]);

    const [updateLoading, , , , runUpdateLimitOffset] = useFetch({
        fetchFn: () =>
            stores.walletStore.updateCourierWalletCashOnDeliveryLimitOffset(payloadRef.current),
        initialCall: false,
        callbackFunc: result => {
            if (!result?.success) return; // hata zaten error modal ile gösterildi
            message.success("Nakit alınabilir sipariş tutar limiti başarıyla güncellendi.");
            setVisible(false);
            onSuccess?.();
        }
    });

    const handleSave = () => {
        payloadRef.current = {courierId, cashOnDeliveryLimitOffset: newLimitOffset};
        runUpdateLimitOffset();
    };

    const handleCancel = () => {
        setNewLimitOffset(cashOnDeliveryLimitOffset);
        setVisible(false);
    };

    return (
        <Popover
            trigger="click"
            placement="bottom"
            visible={visible}
            onVisibleChange={nextVisible => (nextVisible ? setVisible(true) : handleCancel())}
            overlayStyle={{width: "280px"}}
            content={
                <>
                    <div style={{marginBottom: 8}}>Nakit Alınabilir Sipariş Tutar Limiti :</div>
                    <InputNumber
                        placeholder="Nakit Alınabilir Sipariş Tutar Limiti"
                        style={{width: "100%"}}
                        value={newLimitOffset}
                        onChange={value => setNewLimitOffset(value)}
                        precision={2}
                        disabled={updateLoading}
                    />
                    <Space style={{marginTop: 12, width: "100%", justifyContent: "flex-end"}}>
                        <Button size="small" onClick={handleCancel} disabled={updateLoading}>
                            İptal
                        </Button>
                        <Button
                            size="small"
                            type="primary"
                            onClick={handleSave}
                            loading={updateLoading}
                            disabled={newLimitOffset === null || newLimitOffset === undefined}
                        >
                            Kaydet
                        </Button>
                    </Space>
                </>
            }
        >
            <Button
                type="text"
                size="small"
                icon={<EditOutlined />}
                style={{padding: 0, height: "auto", lineHeight: 1}}
            />
        </Popover>
    );
};
